<template>
  <div>
    <input
      class="form-control"
      :class="{ 'is-invalid': !valid }"
      type="text"
      ref="autocomplete"
      @input="valid = true"
      :value="initvalue"
    />
    <div class="small text-danger" v-show="!valid">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  props:['initvalue'],
  data() {
    return {
      autocompleteHandler: null,
      valid: true,
      errorMessage: 'Ingrese una dirección válida, sin piso, departamento o unidad'
    };
  },
  async mounted() {
    const google = window.google;

    this.autocompleteHandler = new google.maps.places.Autocomplete(
      this.$refs.autocomplete,
      { types: ["geocode"] }
    );
    this.autocompleteHandler.setFields(["geometry", "address_components"]);
    this.autocompleteHandler.addListener("place_changed", this.onPlaceChanged);
    if (this.initvalue !== ''){
      const e = document.createEvent('HTMLEvents');
      e.initEvent('keyUp', false, true);
      this.$refs.autocomplete.dispatchEvent(e);
    }
  },
  methods: {
    onPlaceChanged: function() {
      if (this.autocompleteHandler.getPlace().geometry === undefined) {
        this.valid = false;
        this.errorMessage = 'Ingrese una dirección válida, sin piso, departamento o unidad'
      } else {
        let country = ''
        this.autocompleteHandler.getPlace()
            .address_components.forEach(addressComponent => {
              if (addressComponent.types.includes('country')) {
                country = addressComponent.short_name
              }
            });
        console.log(country)
        if (country !== 'AR') {
          this.valid = false;
          this.errorMessage = 'Sólo se aceptan direcciones de Argentina'
          return
        }
        this.$emit("address-change", {
          lat: this.autocompleteHandler.getPlace().geometry.location.lat(),
          lng: this.autocompleteHandler.getPlace().geometry.location.lng(),
          text: this.$refs.autocomplete.value,
          address_components: this.autocompleteHandler.getPlace()
            .address_components
        });
      }
    }
  }
};
</script>
